import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'
import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import * as verifydocumentapi from '../../../apis/verifydocumentupload'
import { FaPlus } from 'react-icons/fa';
import useDebounce from '../../../utils/useDebounce';
import TriggerVerificationModal from '../TriggerVerificationModal';
import { adminTriggerVerification } from '../../../apis/verification_request_by_user';

function BadgeRequest() {
  const allbadgerequestApis = require("../../../apis/badge_request");

  // console.log(hassubfetureEditComment,'hassubfetureEditComment')
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true); // Add a loading state
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [AllFeed, setAllfeed] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [pageRange, setPageRange] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]); // Visible page range
  const [inputPageNumber, setInputPageNumber] = useState(''); // State to hold the input page number
  const [inputFocus, setInputFocus] = useState(false);
  const [buttonFocus, setButtonFocus] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null); // State to track selected row
  const [statusFilter, setStatusFilter] = useState(queryParams.get('status') || '');
  const [typeFilter, setTypeFilter] = useState('all_badges');
  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const [reviewingRequestId, setReviewingRequestId] = useState(null);
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(() => {
    const status = queryParams.get('status');
    if (status) {
      setStatusFilter(status);
    }
  }, [queryParams]);

  const FeatchAllBadgeRequestInfo = React.useCallback(async (page, searchTerm = "", status = "", type = "") => {
    try {
      setLoading(true);

      const response = await allbadgerequestApis.getAllBadgeRequestInfo(page, searchTerm, status, type);
      setAllfeed(response?.data || []);
      console.log(response?.data, 'response?.data')
      setTotalPages(response?.pagination?.pages || 1);
      setFilteredUsers(response?.data || [])

    } catch (error) {
      console.error("Error fetching feed:", error);
    } finally {
      setLoading(false);
    }
  }, [allbadgerequestApis, currentPage, debouncedSearchTerm, statusFilter, typeFilter]);

  useEffect(() => {
    FeatchAllBadgeRequestInfo(currentPage, debouncedSearchTerm, statusFilter, typeFilter);
  }, [currentPage, debouncedSearchTerm, statusFilter, typeFilter, FeatchAllBadgeRequestInfo]);

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);

    const filtered = AllFeed.filter(
      (user) =>
        user?.user?.username.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredUsers(filtered);
  };

  useEffect(() => {
    const initialRange = [];
    const rangeSize = 10;
    const totalVisiblePages = Math.min(rangeSize, totalPages);

    for (let i = 1; i <= totalVisiblePages; i++) {
      initialRange.push(i);
    }
    setPageRange(initialRange);
  }, [totalPages]);

  const updatePageRange = (startPage) => {
    const rangeSize = 10; // Number of pages visible at a time
    const newRange = [];

    for (
      let i = startPage;
      i < startPage + rangeSize && i <= totalPages;
      i++
    ) {
      newRange.push(i);
    }

    setPageRange(newRange);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);

    // If the clicked page is the last in the current range, load the next range
    if (page === pageRange[pageRange.length - 1] && page < totalPages) {
      updatePageRange(page);
    }

    // If the clicked page is the first in the current range and not the first page
    if (page === pageRange[0] && page > 1) {
      updatePageRange(page - 9);
    }
  };

  const handleFirst = () => {
    setCurrentPage(1);
    updatePageRange(1);
  };

  const handleLast = () => {
    setCurrentPage(totalPages);
    const lastRangeStart = Math.max(
      1,
      Math.floor((totalPages - 1) / 10) * 10 + 1
    );
    updatePageRange(lastRangeStart);
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      // Check if we are at the start of the current visible range
      if (currentPage === pageRange[0]) {
        // If we are at the first page of the range, move to the previous set of pages
        const previousRangeStart = Math.max(pageRange[0] - 10, 1); // Ensure start page is >= 1
        updatePageRange(previousRangeStart);
      } else {
        setCurrentPage(currentPage - 1);
      }
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      // If we are at the end of the current visible range, load the next range
      if (currentPage === pageRange[pageRange.length - 1] && currentPage < totalPages) {
        updatePageRange(pageRange[pageRange.length - 1]);
      } else {
        setCurrentPage(currentPage + 1);
      }
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm, statusFilter, typeFilter]);

  const handleGoToPage = () => {
    const page = parseInt(inputPageNumber, 10);

    // Ensure the page number is a valid number and within the valid range
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);

      // Calculate the range for the current page
      const startPage = Math.floor((page - 1) / 10) * 10 + 1;
      updatePageRange(startPage);
    } else {
      alert('Please enter a valid page number!');
    }
  };
  const handleRowClick = (transactionId) => {
    setSelectedRow(transactionId);
  };

  const handleReview = async (requestId, status, reason = "") => {
    const confirmed = window.confirm(`Are you sure you want to ${status} this request?`);
    if (!confirmed) return;

    try {
      setLoading(true);
      const response = await verifydocumentapi.reviewVerificationRequest(requestId, status, reason);
      if (response.success) {
        alert(`Request ${status} successfully`);
        setIsRejectionModalOpen(false);
        setRejectionReason('');
        FeatchAllBadgeRequestInfo(currentPage, debouncedSearchTerm, statusFilter, typeFilter);
      } else {
        alert(response.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      alert(`Error processing ${status}`);
    } finally {
      setLoading(false);
    }
  };

  const openRejectionModal = (requestId) => {
    setReviewingRequestId(requestId);
    setIsRejectionModalOpen(true);
  };

  const handleApprovedBadgeRequest = async (id) => {
    handleReview(id, 'approved');
  };

  const handleUndoApproval = async (requestId) => {
    const confirmed = window.confirm(`Are you sure you want to undo approval for this request?`);
    if (!confirmed) return;

    try {
      setLoading(true);
      const response = await verifydocumentapi.undoApproval(requestId);
      if (response.success) {
        alert(response.message || `Approval undone successfully`);
        FeatchAllBadgeRequestInfo(currentPage, debouncedSearchTerm, statusFilter, typeFilter);
      } else {
        alert(response.message || `Failed to undo approval`);
      }
    } catch (error) {
      console.error(`Error undoing approval:`, error);
      alert(`Error undoing approval`);
    } finally {
      setLoading(false);
    }
  };

  const handleTriggerRequest = async (data) => {
    try {
      const response = await adminTriggerVerification(data);
      if (response.success) {
        alert(response.message || 'Badge request sent successfully');
        FeatchAllBadgeRequestInfo(currentPage, debouncedSearchTerm, statusFilter, typeFilter);
      } else {
        alert(response.message || 'Failed to send badge request');
      }
    } catch (error) {
      console.error('Error triggering badge request:', error);
      alert('Error sending badge request');
    }
  };
  return (

    <IncludeSideBar>
      <h1> Display All Badge Request Info</h1>


      <div>
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <input
            type="text"
            placeholder="Search by username"
            value={searchTerm}
            onChange={handleSearch}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="all_badges">All Badge Types</option>
            <option value="basic_badge">Basic Badge</option>
            <option value="black_badge">Black Badge</option>
            <option value="agent_badge">Agent Badge</option>
            <option value="business_badge">Business Badge</option>
            <option value="premium_badge">Premium Badge</option>
          </select>

          <button
            onClick={() => setIsTriggerModalOpen(true)}
            style={{
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#1a237e',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontWeight: '600',
              marginLeft: 'auto'
            }}
          >
            <FaPlus /> Send Badge Request
          </button>
        </div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
        {!loading && (
          <table>
            <thead>
              <tr>
                <th> ID</th>
                <th>User Id</th>
                <th>Username</th>
                <th>
                  Requested Badge Type</th>
                <th>
                  Requested Time
                </th>
                <th>
                  status                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((badge) => {
                  return (
                    <tr key={badge.id}
                      onClick={() => handleRowClick(badge.id)}

                      style={{
                        backgroundColor: selectedRow === badge.id ? '#91b7e6' : 'transparent',
                        color: selectedRow === badge.id ? 'white' : 'black',
                        cursor: 'pointer', // Change cursor to pointer for better UX
                      }}
                    >
                      <td>{badge?.id}</td>

                      <td>{badge?.user_id || "N/A"}</td>
                      <td>{badge?.user?.username || "N/A"}</td>
                      <td>{badge?.type || "N/A"}</td>

                      <td>
                        {badge.createdAt

                          ? new Date(badge.createdAt).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td>{badge?.status || "N/A"}</td>

                      <td>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          {badge?.status?.toLowerCase() === 'pending' && (
                            <>
                              <button
                                onClick={() => handleApprovedBadgeRequest(badge?.id)}
                                style={{
                                  backgroundColor: '#007bff',
                                  color: 'white',
                                  padding: '5px 10px',
                                  border: 'none',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                }}
                              >
                                Approve Request
                              </button>

                              <button
                                onClick={() => openRejectionModal(badge?.id)}
                                style={{
                                  backgroundColor: '#dc3545',
                                  color: 'white',
                                  padding: '5px 10px',
                                  border: 'none',
                                  borderRadius: '5px',
                                  cursor: 'pointer',
                                }}
                              >
                                Reject Request
                              </button>
                            </>
                          )}
                          {badge?.status?.toLowerCase() === 'approved' && (
                            <button
                              onClick={() => handleUndoApproval(badge?.id)}
                              style={{
                                backgroundColor: '#ffc107',
                                color: 'black',
                                padding: '5px 10px',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                              }}
                            >
                              Undo Approval
                            </button>
                          )}
                        </div>

                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="11">No Request found</td>
                </tr>
              )}

            </tbody>
          </table>
        )}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <button onClick={handleFirst} disabled={currentPage === 1}>
              First
            </button>
            <button onClick={handlePrevious} disabled={currentPage === 1}>
              Previous
            </button>
            {pageRange.map((page) => (
              <button
                key={page}
                onClick={() => handlePageClick(page)}
                style={{
                  padding: "5px 10px",
                  backgroundColor: currentPage === page ? "red" : "#f8f9fa",
                  color: currentPage === page ? "white" : "black",
                  border: "1px solid #ddd",
                  cursor: "pointer",
                }}
              >
                {page}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              Next
            </button>
            <button onClick={handleLast} disabled={currentPage === totalPages}>
              Last
            </button>
          </div>
          {/* direct page */}
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginLeft: '10px' }}>
            <input
              type="number"
              value={inputPageNumber}
              onChange={(e) => setInputPageNumber(e.target.value)}
              placeholder="Page No"
              style={{
                padding: '5px',
                fontSize: '14px',
                // border: '1px solid #ccc',
                border: `2px solid ${inputFocus ? 'green' : '#ccc'}`,

                borderRadius: '4px 0 0 4px',
                outline: 'none',
                width: '90px'
              }}
              onFocus={() => setInputFocus(true)}
              onBlur={() => setInputFocus(false)}
            />
            <button
              onClick={handleGoToPage}
              style={{
                padding: '6.5px 10px',
                fontSize: '14px',
                border: '1px solid #ccc',
                borderLeft: 'none',
                borderRadius: '0 4px 4px 0',
                // backgroundColor: '#007bff',

                backgroundColor: `${buttonFocus ? 'green' : '#007bff'}`,
                color: 'white',
                cursor: 'pointer',
                outline: 'none',
              }}


            >
              Go
            </button>
          </div>

        </div>

      </div>
      {isRejectionModalOpen && (
        <RejectionModal
          onClose={() => setIsRejectionModalOpen(false)}
          onReject={(reason) => handleReview(reviewingRequestId, 'rejected', reason)}
        />
      )}
      <TriggerVerificationModal
        isOpen={isTriggerModalOpen}
        onClose={() => setIsTriggerModalOpen(false)}
        onTrigger={handleTriggerRequest}
        initialType="basic_badge"
      />
    </IncludeSideBar>


  )
}

export default BadgeRequest;

const RejectionModal = ({ onClose, onReject }) => {
  const [reason, setReason] = useState('');

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1100,
  };

  const contentStyle = {
    background: 'white',
    padding: '20px',
    borderRadius: '8px',
    width: '400px',
    textAlign: 'center',
  };

  const textareaStyle = {
    width: '100%',
    height: '100px',
    margin: '10px 0',
    padding: '8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  };

  const buttonStyle = {
    padding: '8px 16px',
    margin: '0 5px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
  };

  return (
    <div style={modalStyle}>
      <div style={contentStyle}>
        <h3>Rejection Reason</h3>
        <textarea
          style={textareaStyle}
          placeholder="Enter reason for rejection..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <div>
          <button
            style={{ ...buttonStyle, backgroundColor: '#dc3545', color: 'white' }}
            onClick={() => {
              if (!reason.trim()) {
                alert('Please provide a reason');
                return;
              }
              onReject(reason);
            }}
          >
            Confirm Reject
          </button>
          <button
            style={{ ...buttonStyle, backgroundColor: '#6c757d', color: 'white' }}
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};


